<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <h1>Mapa de Análisis Criminal</h1>
        <div id="map" style="height: 500px;"></div>
      </v-col>
      <v-col cols="4">
        <v-card>
          <v-card-title>Detalles de Ubicación</v-card-title>
          <v-card-text>
            <p>Información sobre las ubicaciones seleccionadas en el mapa.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  name: 'MapaView',
  mounted() {
    const map = L.map('map').setView([51.505, -0.09], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
  }
}
</script>

<style scoped>
#map {
  width: 100%;
  height: 500px;
}
</style>
